export default __webpack_public_path__ + "static/media/21_tag_kitchenware-tableware.4b83274e.svg";